const caretDropSharpSVG = `
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 1L1 9L8.5 16.5" stroke="black" stroke-opacity="0.6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
`

export default caretDropSharpSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/caretDropSharpSVG.js